import './Styles/Main.scss';

import ConsentManager from './Imports/Vendor/ConsentManager/ConsentManager';

import AirDatepicker from 'air-datepicker';
import localeDe from 'air-datepicker/locale/de';

import $ from 'jquery';
window.$ = $;
window.jQuery = $;

import('./Imports/Flex.js').then(module => {

    'use strict';

    // Slideshows
    import('./Imports/Slideshow.js').then(slideshow => {
        $('#impressionen').slideshow({
            autoplay: true,
            controls: false,
            items: 'figure'
        });
    });

    // Animate On-Page Anchor-Links
    $('a[href*="#"]').on('click', function (e) {
        var anchor = $(this.hash);
        if (anchor.length) {
            e.preventDefault();
            $('html, body').animate({scrollTop: anchor.offset().top}, 1000);
        }
    });

    // Toggle Menu State
    $('#nav').on('click', function (e) {
        e.stopPropagation();
        $(this).toggleClass('hover');
    });
    $(window).on('click', function () {
        $('#nav').removeClass('hover');
    });

    // Equalize Flex Articles
    $('body:not(#page-1)').Flex({
        equalize: ['header', 'article']
    });

    // Impressum / Datenschutz
    $(document).on('click', 'a[href*="#impressum"], a[href*="#datenschutz"]', function() :void {
        $('#impressum').toggleClass('visible');
    });
    if ('#impressum' === window.location.hash || '#datenschutz' === window.location.hash) {
        $('#impressum').toggleClass('visible');
        document.querySelector(window.location.hash)?.scrollIntoView({ behavior: 'smooth' });
    }

    // Scrolling
    $(window).on('scroll', function () {
        if ($(window).scrollTop() >= $(window).height() && !$('body').hasClass('scrolled')) {
            $('body').addClass('scrolled');
        }
        else if ($(window).scrollTop() < $(window).height() && $('body').hasClass('scrolled')) {
            $('body').removeClass('scrolled');
        }
    });
    $(window).scroll();

    // Accordions
    $('.accordion').each(function () {
        var accordion = $(this);
        var header = accordion.find('header');
        var content = accordion.find('.text p:not(:first-of-type), .text ul, .text ol');
        var newContent = $('<div class="accordion-content">').appendTo(accordion);
        header.addClass('accordion-header');
        $('.accordion').removeClass('active');
        accordion.on('click', function () {
            accordion.toggleClass('active');
        });
        content.appendTo(newContent);
    });

    // Team
    $('#team figure').on('mouseenter', function () {
        $(this).siblings().attr('class', 'smaller');
        $(this).attr('class', 'larger');
    });
});

document.addEventListener('DOMContentLoaded', () :void => {

    const consentManagerOptions :{} = {
        interfaceLayout: ConsentManager.LAYOUT_CENTER,
        interfaceTheme: ConsentManager.THEME_LIGHT,
        debug: false,
        privacyUri: '/#datenschutz'
    };

    const consentManagerTags :ConsentManager.Tag[] = [
        new ConsentManager.Tag.IFrameTag({
            name: 'google-maps',
            label: 'Google Maps',
            uri: '/#datenschutz',
        })
    ];

    const consentManager :ConsentManager = new ConsentManager(
        consentManagerOptions,
        consentManagerTags,
        {}
    );

    /*
     * Datepicker
     */
    new AirDatepicker('#terminvereinbarung-90-date', {
        locale: localeDe,
        minDate: new Date(),
        visible: false // leave it open to inspect it
    });

});